import { Theme } from '../../../src/types/index.js'

export const theme: Theme = {
  id: 'classic-eggplant',
  name: 'Classic eggplant',
  palette: {
    primary: '#431241',
    accent: '#1BB78A',
    neutral: '#F1F0ED',
  },
  light1: {
    'action-primary': '#4A154B',
    'action-primary-hovered': '#812383',
    'action-primary-pressed': '#89508a',
    'action-primary-subdued': '#faf8fa',
    'action-primary-subdued-hovered': '#f5f1f5',
    'action-primary-subdued-pressed': '#ecdbe9',
    'action-primary-disabled': '#f8f7f4',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#f8f7f4',
    'action-neutral-pressed': '#f3f2ef',
    'action-neutral-subdued': '#f3f2ef',
    'action-neutral-subdued-hovered': '#e8e7e4',
    'action-neutral-subdued-pressed': '#d5d4d1',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f3f2ef',
    background: '#f3f2ef',
    'background-hovered': '#DCEEE4',
    'background-pressed': '#E6CDE6',
    'background-selected': '#743375',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#a2a29f',
    content: '#250e25',
    'content-subdued': '#5D545D',
    'content-muted': '#737270',
    'content-hovered': '#171717',
    'content-pressed': '#545453',
    'content-disabled': '#a2a29f',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00265b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#451047',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f8f7f4',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#250e25',
    'content-on-background-subdued': '#4A154B',
    'content-on-background-hovered': '#171717',
    'content-on-background-pressed': '#4A154B',
    'content-on-background-disabled': '#a2a29f',
    interactive: '#39bd95',
    'interactive-hovered': '#32ebb3',
    'interactive-pressed': '#2e9475',
    'interactive-disabled': '#f8f7f4',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f8f7f4',
    topbar: '#FFFFFF',
    'topbar-subdued': '#f3f2ef',
    'content-on-topbar': '#4A154B',
    'line-on-topbar': '#d5d4d1',
    'line-on-topbar-pressed': '#737270',
    link: '#2BAC76',
    'link-hovered': '#3bda97',
    'link-pressed': '#249264',
    line: '#d5d4d1',
    'line-subdued': '#f1efea',
    'line-hovered': '#a2a29f',
    'line-pressed': '#737270',
    'line-selected': '#545453',
    'line-disabled': '#e8e7e4',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#0051a8',
    'line-highlight-subdued': '#b5d7ff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#39bd95',
    skeleton: '#e8e7e4',
    surface: '#FFFFFF',
    'surface-subdued': '#f3f2ef',
    'surface-hovered': '#FFF8FF',
    'surface-subdued-hovered': '#e8e7e4',
    'surface-pressed': '#e8e7e4',
    'surface-disabled': '#f8f7f4',
    'surface-selected': '#faf8fa',
    'surface-selected-hovered': '#f5f1f5',
    'surface-selected-pressed': '#ece4eb',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#d6e9ff',
    'surface-highlight-subdued': '#f4f9ff',
    'surface-highlight-subdued-hovered': '#e9f3ff',
    'surface-highlight-subdued-pressed': '#d6e9ff',
    'surface-neutral': '#e8e7e4',
    'surface-neutral-subdued': '#f8f7f4',
    'surface-inverse': '#171717',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light2: {
    'action-primary': '#812383',
    'action-primary-hovered': '#8b438c',
    'action-primary-pressed': '#562957',
    'action-primary-subdued': '#f6f2f6',
    'action-primary-subdued-hovered': '#f5f1f5',
    'action-primary-subdued-pressed': '#ece4eb',
    'action-primary-disabled': '#f8f7f4',
    'action-neutral': '#FFFFFF',
    'action-neutral-hovered': '#f8f7f4',
    'action-neutral-pressed': '#f3f2ef',
    'action-neutral-subdued': '#f3f2ef',
    'action-neutral-subdued-hovered': '#f6f2f6',
    'action-neutral-subdued-pressed': '#d5d4d1',
    'action-neutral-disabled': '#FFFFFF',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f3f2ef',
    background: '#FFFFFF',
    'background-hovered': '#DCEEE4',
    'background-pressed': '#E6CDE6',
    'background-selected': '#ece6ec',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#a2a29f',
    content: '#070606',
    'content-subdued': '#5D545D',
    'content-muted': '#737270',
    'content-hovered': '#171717',
    'content-pressed': '#545453',
    'content-disabled': '#a2a29f',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00265b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#451047',
    'content-on-primary': '#fff2ff',
    'content-on-inverse': '#f8f7f4',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#070606',
    'content-on-background-subdued': '#4A154B',
    'content-on-background-hovered': '#171717',
    'content-on-background-pressed': '#4A154B',
    'content-on-background-disabled': '#a2a29f',
    interactive: '#39bd95',
    'interactive-hovered': '#32ebb3',
    'interactive-pressed': '#2e9475',
    'interactive-disabled': '#f8f7f4',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f8f7f4',
    topbar: '#FFFFFF',
    'topbar-subdued': '#f3f2ef',
    'content-on-topbar': '#503b51',
    'line-on-topbar': '#d5d4d1',
    'line-on-topbar-pressed': '#737270',
    link: '#39bd95',
    'link-hovered': '#32ebb3',
    'link-pressed': '#2e9475',
    line: '#d5d4d1',
    'line-subdued': '#f6f4f1',
    'line-hovered': '#a2a29f',
    'line-pressed': '#737270',
    'line-selected': '#545453',
    'line-disabled': '#e8e7e4',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#0051a8',
    'line-highlight-subdued': '#b5d7ff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#39bd95',
    skeleton: '#efede7',
    surface: '#FFFFFF',
    'surface-subdued': '#f3f2ef',
    'surface-hovered': '#f6f2f6',
    'surface-subdued-hovered': '#f6f2f6',
    'surface-pressed': '#e9e3eb',
    'surface-disabled': '#f8f7f4',
    'surface-selected': '#f1eaf1',
    'surface-selected-hovered': '#f6f2f6',
    'surface-selected-pressed': '#ece4eb',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#d6e9ff',
    'surface-highlight-subdued': '#f4f9ff',
    'surface-highlight-subdued-hovered': '#e9f3ff',
    'surface-highlight-subdued-pressed': '#d6e9ff',
    'surface-neutral': '#f6f2f6',
    'surface-neutral-subdued': '#f8f7f4',
    'surface-inverse': '#171717',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  light3: {
    'action-primary': '#812383',
    'action-primary-hovered': '#8b438c',
    'action-primary-pressed': '#562957',
    'action-primary-subdued': '#faf8fa',
    'action-primary-subdued-hovered': '#f1e3f1',
    'action-primary-subdued-pressed': '#ebdae9',
    'action-primary-disabled': '#f8f7f4',
    'action-neutral': '#f3f2ef',
    'action-neutral-hovered': '#ebe8e1',
    'action-neutral-pressed': '#dad7ce',
    'action-neutral-subdued': '#e8e7e4',
    'action-neutral-subdued-hovered': '#d5d4d1',
    'action-neutral-subdued-pressed': '#d5d4d1',
    'action-neutral-disabled': '#f8f7f4',
    'action-destructive': '#d83028',
    'action-destructive-hovered': '#a71613',
    'action-destructive-pressed': '#840a08',
    'action-destructive-subdued': '#fff5f3',
    'action-destructive-subdued-hovered': '#fff0ec',
    'action-destructive-subdued-pressed': '#ffe0da',
    'action-destructive-disabled': '#f3f2ef',
    background: '#FFFFFF',
    'background-hovered': '#FFF8FF',
    'background-pressed': '#DCEEE4',
    'background-selected': '#eeddee',
    'background-backdrop': '#00000080',
    'background-overlay': '#ffffff80',
    'background-divider': '#a2a29f',
    content: '#250e25',
    'content-subdued': '#5D545D',
    'content-muted': '#737270',
    'content-hovered': '#171717',
    'content-pressed': '#545453',
    'content-disabled': '#a2a29f',
    'content-on-positive': '#004b22',
    'content-on-attention': '#663200',
    'content-on-highlight': '#00265b',
    'content-on-negative': '#840a08',
    'content-on-negative-hovered': '#580202',
    'content-on-negative-pressed': '#380101',
    'content-primary': '#451047',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#f8f7f4',
    'content-on-destructive': '#FFFFFF',
    'content-on-interactive': '#FFFFFF',
    'content-on-background': '#250e25',
    'content-on-background-subdued': '#49284a',
    'content-on-background-hovered': '#171717',
    'content-on-background-pressed': '#340a36',
    'content-on-background-disabled': '#a2a29f',
    interactive: '#39bd95',
    'interactive-hovered': '#32ebb3',
    'interactive-pressed': '#2e9475',
    'interactive-disabled': '#f8f7f4',
    'interactive-destructive': '#d83028',
    'interactive-destructive-hovered': '#a71613',
    'interactive-destructive-pressed': '#840a08',
    'interactive-destructive-disabled': '#f8f7f4',
    topbar: '#f3f2ef',
    'topbar-subdued': '#e8e7e4',
    'content-on-topbar': '#070606',
    'line-on-topbar': '#d5d4d1',
    'line-on-topbar-pressed': '#737270',
    link: '#2BAC76',
    'link-hovered': '#3bda97',
    'link-pressed': '#249264',
    line: '#d5d4d1',
    'line-subdued': '#fdfcfa',
    'line-hovered': '#a2a29f',
    'line-pressed': '#737270',
    'line-selected': '#545453',
    'line-disabled': '#e8e7e4',
    'line-transparent': '#0000001a',
    'line-positive': '#00612f',
    'line-positive-subdued': '#90e6af',
    'line-highlight': '#0051a8',
    'line-highlight-subdued': '#b5d7ff',
    'line-negative': '#a71613',
    'line-negative-subdued': '#ffc7bc',
    'line-negative-disabled': '#ffe0da',
    'line-attention': '#844200',
    'line-attention-subdued': '#ffcb89',
    focused: '#39bd95',
    skeleton: '#e8e7e4',
    surface: '#FBFAF8',
    'surface-subdued': '#e8e7e4',
    'surface-hovered': '#ffffff',
    'surface-subdued-hovered': '#d5d4d1',
    'surface-pressed': '#f1efeb',
    'surface-disabled': '#f8f7f4',
    'surface-selected': '#faf8fa',
    'surface-selected-hovered': '#f5f1f5',
    'surface-selected-pressed': '#ece4eb',
    'surface-attention': '#ffe2bb',
    'surface-attention-subdued': '#fff7ed',
    'surface-negative': '#ffe0da',
    'surface-negative-subdued': '#fff5f3',
    'surface-negative-subdued-hovered': '#fff0ec',
    'surface-negative-subdued-pressed': '#ffe0da',
    'surface-positive': '#c1f2d0',
    'surface-positive-subdued': '#f2fbf5',
    'surface-highlight': '#d6e9ff',
    'surface-highlight-subdued': '#f4f9ff',
    'surface-highlight-subdued-hovered': '#e9f3ff',
    'surface-highlight-subdued-pressed': '#d6e9ff',
    'surface-neutral': '#e8e7e4',
    'surface-neutral-subdued': '#f8f7f4',
    'surface-inverse': '#171717',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark1: {
    'action-primary': '#612162',
    'action-primary-hovered': '#762b78',
    'action-primary-pressed': '#411641',
    'action-primary-subdued': '#393144',
    'action-primary-subdued-hovered': '#44384d',
    'action-primary-subdued-pressed': '#35283c',
    'action-primary-disabled': '#40403f',
    'action-neutral': '#27242C',
    'action-neutral-hovered': '#342f3b',
    'action-neutral-pressed': '#1f1a22',
    'action-neutral-subdued': '#292828',
    'action-neutral-subdued-hovered': '#40403f',
    'action-neutral-subdued-pressed': '#545453',
    'action-neutral-disabled': '#40403f',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#40403f',
    background: '#1A1D21',
    'background-hovered': '#27242C',
    'background-pressed': '#3A2D3B',
    'background-selected': '#1a181e',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#a2a2a0',
    content: '#f8f7f5',
    'content-subdued': '#d5d4d3',
    'content-muted': '#a2a2a0',
    'content-hovered': '#f3f2f0',
    'content-pressed': '#d5d4d3',
    'content-disabled': '#737271',
    'content-on-positive': '#f4faf6',
    'content-on-attention': '#fff7f1',
    'content-on-highlight': '#f5f8fd',
    'content-on-negative': '#fff6f4',
    'content-on-negative-hovered': '#ffefec',
    'content-on-negative-pressed': '#ffdfda',
    'content-primary': '#f4f2f4',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#171717',
    'content-on-destructive': '#f8f7f5',
    'content-on-interactive': '#f8f7f5',
    'content-on-background': '#f8f7f5',
    'content-on-background-subdued': '#d3d1cc',
    'content-on-background-hovered': '#f3f2f0',
    'content-on-background-pressed': '#FBFAF7',
    'content-on-background-disabled': '#737271',
    interactive: '#2EB67D',
    'interactive-hovered': '#37d291',
    'interactive-pressed': '#28a26f',
    'interactive-disabled': '#171717',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#171717',
    topbar: '#211221',
    'topbar-subdued': '#2f1b2f',
    'content-on-topbar': '#f8f7f5',
    'line-on-topbar': '#40403f',
    'line-on-topbar-pressed': '#737271',
    link: '#2EB67D',
    'link-hovered': '#37d291',
    'link-pressed': '#28a26f',
    line: '#40403f',
    'line-subdued': '#40403f',
    'line-hovered': '#545453',
    'line-pressed': '#737271',
    'line-selected': '#545453',
    'line-disabled': '#40403f',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#051730',
    'line-highlight-subdued': '#051730',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#f0c9f1',
    skeleton: '#40403f',
    surface: '#27242C',
    'surface-subdued': '#2c2932',
    'surface-hovered': '#3b3643',
    'surface-subdued-hovered': '#504a5a',
    'surface-pressed': '#504a5a',
    'surface-disabled': '#40403f',
    'surface-selected': '#5d4d5d',
    'surface-selected-hovered': '#6a4969',
    'surface-selected-pressed': '#6a4969',
    'surface-attention': '#3c220a',
    'surface-attention-subdued': '#5b3814',
    'surface-negative': '#4a1712',
    'surface-negative-subdued': '#712821',
    'surface-negative-subdued-hovered': '#90372e',
    'surface-negative-subdued-pressed': '#90372e',
    'surface-positive': '#0b2e1a',
    'surface-positive-subdued': '#17492d',
    'surface-highlight': '#0d284c',
    'surface-highlight-subdued': '#1b4071',
    'surface-highlight-subdued-hovered': '#27548f',
    'surface-highlight-subdued-pressed': '#27548f',
    'surface-neutral': '#3b3643',
    'surface-neutral-subdued': '#40403f',
    'surface-inverse': '#f8f7f5',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
  dark2: {
    'action-primary': '#612162',
    'action-primary-hovered': '#762b78',
    'action-primary-pressed': '#411641',
    'action-primary-subdued': '#393144',
    'action-primary-subdued-hovered': '#44384d',
    'action-primary-subdued-pressed': '#35283c',
    'action-primary-disabled': '#40403f',
    'action-neutral': '#1c1a21',
    'action-neutral-hovered': '#312e36',
    'action-neutral-pressed': '#121116',
    'action-neutral-subdued': '#292828',
    'action-neutral-subdued-hovered': '#40403f',
    'action-neutral-subdued-pressed': '#40403f',
    'action-neutral-disabled': '#292828',
    'action-destructive': '#bc5044',
    'action-destructive-hovered': '#90372e',
    'action-destructive-pressed': '#712821',
    'action-destructive-subdued': '#4a1712',
    'action-destructive-subdued-hovered': '#712821',
    'action-destructive-subdued-pressed': '#90372e',
    'action-destructive-disabled': '#40403f',
    background: '#27242C',
    'background-hovered': '#312e36',
    'background-pressed': '#3A2D3B',
    'background-selected': '#201e24',
    'background-backdrop': '#00000080',
    'background-overlay': '#00000080',
    'background-divider': '#a2a2a0',
    content: '#f8f7f5',
    'content-subdued': '#d5d4d3',
    'content-muted': '#a2a2a0',
    'content-hovered': '#f3f2f0',
    'content-pressed': '#d5d4d3',
    'content-disabled': '#737271',
    'content-on-positive': '#f4faf6',
    'content-on-attention': '#fff7f1',
    'content-on-highlight': '#f5f8fd',
    'content-on-negative': '#fff6f4',
    'content-on-negative-hovered': '#ffefec',
    'content-on-negative-pressed': '#ffdfda',
    'content-primary': '#f4f2f4',
    'content-on-primary': '#FFFFFF',
    'content-on-inverse': '#171717',
    'content-on-destructive': '#f8f7f5',
    'content-on-interactive': '#f8f7f5',
    'content-on-background': '#f8f7f5',
    'content-on-background-subdued': '#e1dbea',
    'content-on-background-hovered': '#f8f7f5',
    'content-on-background-pressed': '#FBFAF7',
    'content-on-background-disabled': '#737271',
    interactive: '#2EB67D',
    'interactive-hovered': '#37d291',
    'interactive-pressed': '#28a26f',
    'interactive-disabled': '#171717',
    'interactive-destructive': '#bc5044',
    'interactive-destructive-hovered': '#90372e',
    'interactive-destructive-pressed': '#712821',
    'interactive-destructive-disabled': '#171717',
    topbar: '#1c1a21',
    'topbar-subdued': '#1f1d24',
    'content-on-topbar': '#f8f7f5',
    'line-on-topbar': '#40403f',
    'line-on-topbar-pressed': '#737271',
    link: '#2EB67D',
    'link-hovered': '#37d291',
    'link-pressed': '#28a26f',
    line: '#40403f',
    'line-subdued': '#40403f',
    'line-hovered': '#545453',
    'line-pressed': '#737271',
    'line-selected': '#545453',
    'line-disabled': '#40403f',
    'line-transparent': '#ffffff1a',
    'line-positive': '#051b0e',
    'line-positive-subdued': '#051b0e',
    'line-highlight': '#051730',
    'line-highlight-subdued': '#051730',
    'line-negative': '#2f0b08',
    'line-negative-subdued': '#2f0b08',
    'line-negative-disabled': '#712821',
    'line-attention': '#241304',
    'line-attention-subdued': '#241304',
    focused: '#f0c9f1',
    skeleton: '#40403f',
    surface: '#1c1a21',
    'surface-subdued': '#2c2932',
    'surface-hovered': '#27242C',
    'surface-subdued-hovered': '#504a5a',
    'surface-pressed': '#504a5a',
    'surface-disabled': '#292828',
    'surface-selected': '#504a5a',
    'surface-selected-hovered': '#6a4969',
    'surface-selected-pressed': '#6a4969',
    'surface-attention': '#3c220a',
    'surface-attention-subdued': '#5b3814',
    'surface-negative': '#4a1712',
    'surface-negative-subdued': '#712821',
    'surface-negative-subdued-hovered': '#90372e',
    'surface-negative-subdued-pressed': '#90372e',
    'surface-positive': '#0b2e1a',
    'surface-positive-subdued': '#17492d',
    'surface-highlight': '#0d284c',
    'surface-highlight-subdued': '#1b4071',
    'surface-highlight-subdued-hovered': '#27548f',
    'surface-highlight-subdued-pressed': '#27548f',
    'surface-neutral': '#3b3643',
    'surface-neutral-subdued': '#3b3643',
    'surface-inverse': '#f8f7f5',
    'decorative-surface-1': '#FFC96B',
    'decorative-surface-1-subdued': '#FFE4B5',
    'decorative-content-1': '#7E5700',
    'decorative-surface-2': '#FFC4B0',
    'decorative-surface-2-subdued': '#FFE1D7',
    'decorative-content-2': '#AF294E',
    'decorative-surface-3': '#92E6B5',
    'decorative-surface-3-subdued': '#C9F3DA',
    'decorative-content-3': '#006D41',
    'decorative-surface-4': '#91E0D6',
    'decorative-surface-4-subdued': '#C8EFEB',
    'decorative-content-4': '#006A68',
    'decorative-surface-5': '#FDC9D0',
    'decorative-surface-5-subdued': '#FEE4E7',
    'decorative-content-5': '#AE2B4C',
    'decorative-surface-6': '#7CD4FD',
    'decorative-surface-6-subdued': '#BDE9FE',
    'decorative-content-6': '#065986',
    'decorative-surface-7': '#BDB4FE',
    'decorative-surface-7-subdued': '#DED9FF',
    'decorative-content-7': '#4A1FB8',
  },
}
